/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Or_Reach_Out_InstantlyInputs */

const en_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or reach out instantly`)
};

const es_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O comunícate al instante`)
};

const fr_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou contactez-nous instantanément`)
};

const de_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oder erreiche uns sofort`)
};

const ja_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`または即座に連絡する`)
};

const zh_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`或即时联系`)
};

const ar_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أو تواصل معنا فوراً عبر`)
};

const id_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atau hubungi secara instan`)
};

const it_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oppure contattaci subito`)
};

const ru_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Или свяжитесь немедленно`)
};

const pt_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ou entre em contato instantaneamente`)
};

const ko_or_reach_out_instantly = /** @type {(inputs: Or_Reach_Out_InstantlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`또는 즉시 연락하기`)
};

/**
* | output |
* | --- |
* | "Or reach out instantly" |
*
* @param {Or_Reach_Out_InstantlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const or_reach_out_instantly = /** @type {((inputs?: Or_Reach_Out_InstantlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Or_Reach_Out_InstantlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_or_reach_out_instantly(inputs)
	if (locale === "es") return es_or_reach_out_instantly(inputs)
	if (locale === "fr") return fr_or_reach_out_instantly(inputs)
	if (locale === "de") return de_or_reach_out_instantly(inputs)
	if (locale === "ja") return ja_or_reach_out_instantly(inputs)
	if (locale === "zh") return zh_or_reach_out_instantly(inputs)
	if (locale === "ar") return ar_or_reach_out_instantly(inputs)
	if (locale === "id") return id_or_reach_out_instantly(inputs)
	if (locale === "it") return it_or_reach_out_instantly(inputs)
	if (locale === "ru") return ru_or_reach_out_instantly(inputs)
	if (locale === "pt") return pt_or_reach_out_instantly(inputs)
	return ko_or_reach_out_instantly(inputs)
});